// Frameworks supported by AI Gap & Risk Intelligence - the only frontend list.
// Mirrors cara_backend/api/domains/gap_management/frameworks/registry.py.
//   key           framework_key sent to the backend (save_assessment/<key>/)
//   dashboardName ?framework= value AssessmentsDashboard.jsx DASHBOARD_MAP uses
//   coCapability  capability that opens the framework card (sidebar / routes)
// Display names come from i18n: gap_intelligence:framework.<key>.
export const GAP_FRAMEWORKS = [
  { key: 'nist_csf_2_0', dashboardName: 'NIST-CSF 2.0', coCapability: 'CO NIST CSF 2.0 Assessment' },
  { key: 'ransomware', dashboardName: 'NIST Ransomware', coCapability: 'CO NIST Ransomware Assessment' },
  { key: 'nist_ai_rmf', dashboardName: 'NIST AI RMF', coCapability: 'CO NIST AI RMF Assessment' },
  { key: 'iso_27001', dashboardName: 'ISO 27001:2022', coCapability: 'CO ISO 27001 Assessment' },
  { key: 'cis_v8_1', dashboardName: 'CIS V8.1', coCapability: 'CO CIS V8.1 Assessment' },
  { key: 'rbi_csf', dashboardName: 'RBI CSF Framework', coCapability: 'CO RBI CSF Assessment' },
];

const BY_KEY = Object.fromEntries(GAP_FRAMEWORKS.map((fw) => [fw.key, fw]));

export const getGapFramework = (key) => BY_KEY[key];

export const GAP_FRAMEWORK_CAPABILITIES = GAP_FRAMEWORKS.map((fw) => fw.coCapability);

// True if the user can open at least one supported framework.
export const hasGapFrameworkCapability = (capabilities = []) =>
  GAP_FRAMEWORK_CAPABILITIES.some((cap) => capabilities.includes(cap));

export const assessmentDashboardUrl = (key, cid) =>
  `/assessment_dashboard?framework=${encodeURIComponent(BY_KEY[key].dashboardName)}&cid=${encodeURIComponent(cid)}`;
